import styled from 'styled-components';

import variables from '../../styles/variables';
import prevArrowBlack from '../../images/back-arrow-left-black.svg';
import nextArrowBlack from '../../images/back-arrow-right-black.svg';

export const Section = styled.section<{$fullWidth?: boolean}>`
  width: ${(props) => props.$fullWidth ? '100%' : 'auto'};
  display: flex;
  ${(props) => props.$fullWidth && `max-width: ${variables.defaultWidth}px`};
  padding: 0 ${variables.layoutPadding}rem;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  flex-direction: column;
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
    flex-wrap: wrap;
    margin: 0 20px;
  }

  &.no-margin {
    margin: 0 auto !important;
  }

  &.hero-carousel {
    grid-template:
    'one';
    grid-template-columns: 100%;
    max-width: 100%;
    margin: 0;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.$fullWidth && variables.colorBlackAlt};

    @media screen and (max-width: 640px) {
      margin-bottom: ${(props) => props.$fullWidth && '-5px'};
    }
  }
`;

export const Container = styled.div<{$fullWidth?: boolean;}>`
  width: 100%;
  display: flex;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin: 0 auto;

  @media screen and (max-width: 1280px) {
    padding:0;
  }


  @media screen and (max-width: 1024px) {
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px) {
    height: ${(props) => !props.$fullWidth && 'auto'};
    max-width: ${(props) => !props.$fullWidth && '335px'};
  }

  &.hero-carousel {
    overflow: visible;
    @media screen and (max-width: 640px) {
      padding: 0;
    }
  }
`;

export const Headline = styled.h2`
  width: 100%;
  color: ${variables.colorBlack};
  text-align: center;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: -0.25px;
  font-weight: 600;
  margin-bottom: 2rem;

  @media screen and (max-width: 1024px) {
    font-size: 24px;
    line-height: 40px;
  }

  @media screen and (max-width: 640px) {
    text-align: start;
  }
`;

export const Carousel = styled.div<{$fullWidth?: boolean}>`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  height: ${(props) => !props.$fullWidth && 'auto'};

  .swiper {
    width: calc(100% + 2.1rem);
    height: 100%;
    padding-bottom: 1.5rem;
    margin-left: -1.5rem;
    height: ${(props) => !props.$fullWidth && 'auto'};

    @media screen and (max-width: 767px) {
      overflow: visible !important;
      margin-left: 0;
      width: 100%;
    }

    @media screen and (max-width: 480px) {
      margin-bottom: 1rem;
      padding-bottom: 2.5rem;
    }

    @media screen and (max-width: 375px) {
      margin-left: 0;
      width: 100%;
    }

    .swiper-container {
      height: auto;
    }

    .swiper-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;
      height: ${(props) => !props.$fullWidth && 'auto'};

      .swiper-slide {
        height: auto;
        text-align: center;
        font-size: 18px;
        background: #fff;
        display: flex;
        width: 282px !important;
        margin-top: 10px;
        margin-bottom: 0;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        align-self: stretch;
        background: transparent;
        padding-bottom: 1.5rem;

        @media screen and (max-width: 375px) {
          width: 100% !important;
        }

        &:first-child {
          padding-left: 1.5rem;

          @media screen and (max-width: 767px) {
            padding-left: 0;
          }
        }

        &:last-child {
          padding-right: 1.5rem;

          @media screen and (max-width: 767px) {
            padding-right: 0;
          }
        }

        &.promo {
          &.accessory-promo-small {
            width: 384px !important;

            @media screen and (max-width: 767px) {
              width: 280px !important;
            }

            @media screen and (max-width: 375px) {
              width: 100% !important;
            }
          }

          &.accessory-promo-large {
            width: 600px !important;

            @media screen and (max-width: 767px) {
              width: 280px;
            }

            @media screen and (max-width: 375px) {
              width: 100% !important;
            }
          }
        }

        &.hero-carousel {
          width: 100% !important;
          max-width: 1200px;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      height: 24px;
      width: 24px;
      border-radius: 12px;
      border: 2px solid ${variables.colorWhite};
      box-shadow: 0 2px 5px 0 rgb(0 0 0 / 30%);
      cursor: pointer;
      transition:
        border 400ms ease,
        opacity 400ms ease;

      &.swiper-button-disabled {
        opacity: 0;
        visibility: hidden;
      }

      &:after {
        content: none;
      }

      &:hover,
      &:focus {
        border: 2px solid ${variables.colorGrey};
      }
    }

    .swiper-button-next {
      background-image: url(${nextArrowBlack});
      right: 2px;

      @media screen and (max-width: 767px) {
        right: 0;
      }

      @media screen and (max-width: 480px) {
        right: 2px;
        top: auto;
        bottom: 22px;
      }
    }

    .swiper-button-prev {
      background-image: url(${prevArrowBlack});
      left: 2px;

      @media screen and (max-width: 767px) {
        left: 0;
      }

      @media screen and (max-width: 480px) {
        left: 2px;
        top: auto;
        bottom: 22px;
      }
    }

    .swiper-pagination {
      display: none;
      justify-content: center;
      margin: 0 auto;
      bottom: 28px;
      left: 0;
      right: 0;
      width: calc(100% - 60px);

      @media screen and (max-width: 480px) {
        display: flex;
      }
    }

    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal {
      &.swiper-pagination-bullets {
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          margin: 0 8px;
        }
      }
    }

    .swiper-pagination-bullet-active {
      background: ${variables.colorRed};
    }
  }

  &.hero-carousel {
    max-width: 100%;
    margin-top: 0;
    justify-content: center;
    align-items: ${(props) => props.$fullWidth ? 'center' : 'stretch'};
    background-color: ${(props) => props.$fullWidth && variables.colorBlackAlt};

    .swiper {
      width: 100%;
      height: ${(props) => props.$fullWidth ? '100%' : 'auto'};
      overflow: visible;
      margin-left: 0!important;
      padding-bottom: 2rem;

      @media screen and (max-width: 480px) {
        margin-bottom: 0;
      }

      .swiper-slide {
        padding-bottom: 0.5rem;

        @media screen and (max-width: 480px) {
          padding-bottom: 1.5rem;
        }

        &:first-child {
          padding-left: 0 !important;
        }

        &:last-child {
          padding-right: 0 !important;
        }

        > a {
          height: 100% !important;
        }
      }

      .swiper-button-next {
        background-image: url(${nextArrowBlack});
        right: -12px;

        @media screen and (max-width: 480px) {
          right: 0;
          top: auto;
          bottom: 16px;
        }

        @media screen and (max-width: 375px) {
          right: 20px;
        }
      }

      .swiper-button-prev {
        background-image: url(${prevArrowBlack});
        left: -12px;

        @media screen and (max-width: 480px) {
          left: 0;
          top: auto;
          bottom: 16px;
        }

        @media screen and (max-width: 375px) {
          left: 20px;
        }
      }

      .swiper-pagination {
        display: flex;
        bottom: 14px;

        @media screen and (max-width: 480px) {
          bottom: 22px;
        }
      }
    }
  }
`;
